import { Action, actionsList } from '@dirootie-web/components-types';
import { ButtonProps, ButtonVisualType } from './Buttons.types';
import { di } from '@dirootie-core/di';

type ButtonConfiguration = {
  visual: ButtonVisualType;
  visuals: { [key: string]: ButtonProps };
};

export const defaultButtonDefinitions: ButtonConfiguration = {
  visual: 'text',
  visuals: {
    text: {
      kind: undefined,
      visual: 'text',
      text: undefined,
    },
    icon: {
      kind: undefined,
      visual: 'text',
      text: undefined,
    },
    both: {
      kind: undefined,
      visual: 'text',
      text: undefined,
    },
  },
};

const primaryColor = 'primary';
const basicColor = 'basic';
//const secondaryColor = 'secondary';
const warnColor = 'warn';
const successColor = 'success';
const infoColor = 'info';

export const defaultButtonKindDefinition: {
  [key in Action]: ButtonProps;
} = {
  accept: { color: successColor },
  add: { color: primaryColor },
  approve: { color: successColor },
  back: { color: basicColor },
  cancel: { color: basicColor },
  change: { color: basicColor },
  clear: { color: basicColor },
  close: { color: basicColor },
  confirmation: { color: successColor },
  continue: { color: successColor },
  copy: { color: infoColor },
  create: { color: primaryColor },
  create_field: { color: primaryColor },
  create_form: { color: primaryColor },
  create_new: { color: primaryColor },
  delete: { color: warnColor },
  delete_confirmation: { color: warnColor },
  details: { color: infoColor },
  download: { color: primaryColor },
  edit: { color: infoColor },
  expand: { color: infoColor },
  finish: { color: infoColor },
  generate: { color: infoColor },
  hide: { color: infoColor },
  login: { color: primaryColor },
  logout: { color: primaryColor },
  new: { color: primaryColor },
  no: { color: basicColor },
  preview: { color: infoColor },
  refuse: { color: warnColor },
  register: { color: primaryColor },
  reject: { color: warnColor },
  reload: { color: primaryColor },
  replace: { color: primaryColor },
  resend: { color: primaryColor },
  resend_email: { color: primaryColor },
  save: { color: primaryColor },
  save_create: { color: primaryColor },
  search: { color: infoColor },
  send: { color: primaryColor },
  show: { color: infoColor },
  show_more: { color: infoColor },
  show_less: { color: infoColor },
  start: { color: successColor },
  subscribe: { color: primaryColor },
  submitted: { color: successColor },
  unsubscribe: { color: primaryColor },
  upload: { color: primaryColor },
  upload_replace: { color: primaryColor },
  view: { color: infoColor },
  view_more: { color: infoColor },
  view_less: { color: infoColor },
  yes: { color: basicColor },
  navigate_to: { color: primaryColor },
  navigate_back: { color: primaryColor },
  open_modal: { color: primaryColor },
  confirm: { color: primaryColor },
  help: { color: primaryColor },
  threeD_model: { color: primaryColor },
  review: { color: infoColor },
};

actionsList.forEach(
  (x) => (defaultButtonKindDefinition[x].text = di.str.startCase(x))
);
